import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService 
{
  _appConfig : any;

  constructor(
    private localeservice:LocaleService,
    public platform: Platform
  ) { }

  public initialize(appConfig:any)
  {
    if(appConfig === null || appConfig === undefined)
      throw new Error('appConfig is null or undefined');

    this._appConfig = appConfig;

    return this.localeservice.setLocale(this.getLocale(), this.getCurrency());
  }

  public getAppUrl() : string
  {
    var operatingSystem = this.getOperatingSystem();

    if(this._appConfig.CurrentVersion !== undefined)
    {
      if(operatingSystem === "Android")
      {
        if(this._appConfig.CurrentVersion.AndroidUpdateLink !== undefined)
          return this._appConfig.CurrentVersion.AndroidUpdateLink;
      }
      
      if(operatingSystem === "iOS")
      {
        if(this._appConfig.CurrentVersion.IOSUpdateLink !== undefined)
          return this._appConfig.CurrentVersion.IOSUpdateLink;
      }
    }

    return '';
  }

  public hasApp()
  {
    var operatingSystem = this.getOperatingSystem();

    if(operatingSystem === "Android" || operatingSystem === "iOS")
      return this.getAppUrl() !== '';
      
    return false;
  }

  public getOperatingSystem(): string 
  {
    if (this.platform.ANDROID) 
    {
        return "Android";
    }

    if (this.platform.IOS) 
    {
        return "iOS";
    }

    return "unknown";
  }
  
  public getPrivacyURL()
  {
    if(this._appConfig.PrivacyPolicyURL !== null && this._appConfig.PrivacyPolicyURL !== undefined)
      return String(this._appConfig.PrivacyPolicyURL);
    else
      return '';
  }

  public getUnitID()
  {
    return String(this._appConfig.UnitID);
  }

  public getClientID()
  {
    return String(this._appConfig.ClientID);
  }

  public getLocale()
  {
    return String(this._appConfig.Locale);
  }

  public getCurrency()
  {
    return String(this._appConfig.Currency);
  }

  public getTheme()
  {
    if(this._appConfig && this._appConfig.Theme && typeof this._appConfig.Theme === 'string')
      return String(this._appConfig.Theme);
    else
      return '';
  }

  public getPlaceName()
  {
    if(this._appConfig.DisplayName !== null && this._appConfig.DisplayName !== undefined)
      return String(this._appConfig.DisplayName);

    return '';
  }
}
